type AdminUnauthorizedProps = {
  email?: string;
  onSignOut: () => Promise<void> | void;
};

export default function AdminUnauthorized({ email, onSignOut }: AdminUnauthorizedProps) {
  return (
    <div className="mx-auto max-w-xl rounded-[2rem] border border-red-200 bg-white p-8 shadow-sm">
      <p className="text-sm font-bold uppercase tracking-[0.16em] text-red-600">Access Denied</p>
      <h2 className="mt-3 text-3xl font-black text-slate-900">This account is not approved for admin access</h2>
      <p className="mt-4 text-sm leading-7 text-slate-600">
        {email ? `${email} signed in successfully, but it is not on the approved admin allowlist for this website.` : 'This signed-in account is not on the approved admin allowlist for this website.'}
      </p>
      <p className="mt-4 text-sm leading-7 text-slate-600">
        Please sign out and log in with an approved admin email, or contact the site owner to request access.
      </p>
      <button
        type="button"
        onClick={onSignOut}
        className="mt-6 inline-flex items-center justify-center rounded-full border border-slate-300 px-6 py-3 text-sm font-bold text-slate-700 transition hover:border-[#33b300] hover:text-[#0d4f12]"
      >
        Sign Out
      </button>
    </div>
  );
}
